import Plyr from 'Plyr';

const videoPlayer = document.querySelectorAll('.js-video');

if(videoPlayer){
    const plyrOptions = {
        iconUrl: themeOpts.plyrSvg || '',
    };
    for (let i=0; i<videoPlayer.length; i++){
        const player = new Plyr(videoPlayer[i], plyrOptions);
    }
}

// Auto Play Videos
const autoPlayVideos = document.querySelectorAll('.js-video-autoplay');
if (autoPlayVideos && window.innerWidth >= 768) {
    for (let i = 0; i < autoPlayVideos.length; i++) {
        autoPlayVideos[i].play();
        // TODO: ADD PLAY VIDEO BUTTON FOR MOBILE
    }
}


// WEBPACK FOOTER //
// ./assets/js/src/modules/video-player.js